<template>
  <div :class="'top-line' + (this.openMenu ? ' top-line--open-menu' : '')">
    <m4-toast v-if="toastMessage" delay="10">
      {{ toastMessage }}
    </m4-toast>
    <m4-level no-gutters>
      <m4-level-left class="top-line__app-logo">
        <m4-icon icon="list-alt"></m4-icon>
      </m4-level-left>
      <m4-level-left>
        <form
          v-if="searchFormAction"
          class="top-line__simple-search"
          :action="searchFormAction"
          :method="searchFormMethod"
        >
          <m4-form-field
            :name="searchInputName"
            :default-placeholder="searchInputPlaceholder"
            :value="searchInputValue"
          ></m4-form-field>
          <m4-button type="submit" variant="info" size="md">
            <m4-icon icon="search"></m4-icon>
          </m4-button>
        </form>
        <slot name="next_to_simple_search"></slot>
      </m4-level-left>
      <m4-level-right>
        <div v-if="notificationUrl" class="top-line__item top-line__item--notification">
          <m4-button
            variant="default-text"
            @click="toggleNotificationMenu"
            :class="'top-line__item__notification' + (openUserMenu ? ' top-line__item--opened-user-menu' : '')"
          >
            <span v-if="userNotificationCount > 0" class="top-line__item__counter">
              <em>{{ userNotificationCount }}</em>
            </span>
            <m4-icon icon="bell" class="top-line__item__user"></m4-icon>
          </m4-button>
          <ul
            v-if="openNotificationMenu"
            v-click-outside="onClickOutside"
            :class="
              'top-line__item__submenu top-line__item__submenu--notification' +
              (openNotificationMenu ? ' top-line__item__submenu--opened' : '')
            "
          >
            <li
              v-if="userNotificationItems && userNotificationItems.length === 0"
              class="top-line__item__submenu__li top-line__item__submenu--no-items"
            >
              no notifications
            </li>
            <li
              v-for="(notification, i) in userNotificationItems"
              :key="i"
              :class="
                'top-line__item__submenu__li' +
                (notification.link ? ' top-line__item__submenu__li--link' : '') +
                (notification.isNew ? ' top-line__item__submenu__li--new' : '')
              "
              @click="clickOnNotification(notification)"
            >
              <div v-if="notification.number" class="top-line__item__submenu__li__number">
                {{ notification.number }}
              </div>
              <div v-if="notification.text" class="top-line__item__submenu__li__text" v-html="notification.text"></div>
            </li>
          </ul>
        </div>
        <div v-if="userMenuItems && userMenuItems.length" class="top-line__item top-line__item--user">
          <m4-button
            variant="default-text"
            @click="toggleUserMenu"
            :class="'top-line__item__user-btn' + (openUserMenu ? ' top-line__item--opened-user-menu' : '')"
          >
            <m4-icon icon="user" class="top-line__item__user"></m4-icon>
          </m4-button>
          <ul
            v-if="openUserMenu"
            v-click-outside="onClickOutside"
            :class="'top-line__item__submenu' + (openUserMenu ? ' top-line__item__submenu--opened' : '')"
          >
            <li v-for="(userMenuItem, i) in userMenuItems" :key="i">
              <m4-button variant="default-text" :href="userMenuItem.link" tag="a">
                <m4-icon icon="angle-right"></m4-icon>
                {{ userMenuItem.label }}
              </m4-button>
            </li>
          </ul>
        </div>
        <div class="top-line__item top-line__item--logout">
          <m4-button @click="$emit('logout')" variant="default-text">
            <m4-icon icon="log-out"></m4-icon>
          </m4-button>
        </div>
        <div class="top-line__item top-line__item--mobile-menu">
          <m4-button @click="toggleMenu" variant="default-text" class="top-line__item__menu-btn">
            <m4-menu-icon :menu-open="this.openMenu"></m4-menu-icon>
          </m4-button>
        </div>
      </m4-level-right>
    </m4-level>
  </div>
</template>

<script>
import ClickOutside from "click-outside-vue3";

export default {
  name: "M4TopLine",
  data() {
    return {
      openUserMenu: false,
      openNotificationMenu: false,
      openMenu: false,
      userNotificationCount: 0,
      userNotificationItems: [],
      eventSource: null,
      toastMessage: null
    };
  },
  props: {
    userName: String,
    logout: Function,
    searchInputName: String,
    searchInputPlaceholder: String,
    searchInputValue: String,
    searchFormAction: String,
    searchFormMethod: {
      type: String,
      default: function () {
        return "POST";
      }
    },
    userMenuItems: {
      type: Array,
      default: function () {
        return [];
      }
    },
    notificationUrl: String
  },
  emits: ["logout", "togglnavigationmenu", "toggleusermenu", "togglemenu"],
  mounted() {
    let self = this;
    self.openSse();

    document.addEventListener("visibilitychange", function (e) {
      if (e.target.hidden) {
        self.closeSse();
      } else {
        self.openSse();
      }
    });
  },
  methods: {
    openSse() {
      if (this.notificationUrl && typeof EventSource === "function") {
        let self = this;
        this.eventSource = new EventSource(this.notificationUrl, { withCredentials: true });
        this.eventSource.addEventListener("message", function (e) {
          if (e.data) {
            let response = JSON.parse(e.data);
            if (parseInt(response.count) > 0) {
              self.userNotificationCount = response.count;
            } else {
              self.userNotificationCount = 0;
            }
            if (response.notifications) {
              self.userNotificationItems = response.notifications;
            }
            if (response.toastMessage) {
              self.toastMessage = response.toastMessage;
            }
            if (!response.notifications || response.notifications.length === 0) {
              self.closeSse();
            }
          }
        });
      }
    },
    closeSse() {
      if (this.eventSource) {
        this.eventSource.close();
      }
    },
    toggleMenu() {
      this.openMenu = !this.openMenu;
      this.$emit("togglemenu", this.openMenu);
    },
    toggleUserMenu() {
      this.openUserMenu = !this.openUserMenu;
      this.openNotificationMenu = false;
      this.$emit("toggleusermenu", this.openUserMenu);
    },
    toggleNotificationMenu() {
      this.openNotificationMenu = !this.openNotificationMenu;
      this.openUserMenu = false;
      this.$emit("togglnavigationmenu", this.openNotificationMenu);
    },
    clickOnNotification(notification) {
      if (notification.link) {
        location.href = notification.link;
        return true;
      }
      return false;
    },
    onClickOutside(event) {
      if (
        !event.target.classList.contains("top-line__item__submenu") &&
        !event.target.classList.contains("top-line__item__user-btn") &&
        !event.target.classList.contains("top-line__item__notification")
      ) {
        this.openUserMenu = false;
        this.openNotificationMenu = false;
      }
    }
  },
  directives: {
    clickOutside: ClickOutside.directive
  }
};
</script>
